import { ACCESS_TOKEN_KEY } from '@utils/token/constants';
import Cookies from 'js-cookie';

import { ErrorResponse, RequestError } from './request.type';

export const requestDownload = async ({
  url,
  method,
  body,
  headers,
}: {
  url: string;
  method: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  body?: any;
  headers?: Record<string, string>;
}) => {
  const token = Cookies.get(ACCESS_TOKEN_KEY as string);
  const isBodyFormData = body instanceof FormData;
  const options = {
    headers: {
      ...(token && { Authorization: `Bearer ${token}` }),
      ...headers,
    },
    method,
    body: body ? (isBodyFormData ? body : JSON.stringify(body)) : null,
  };

  const response = await fetch(url, options);

  if (!response.ok) {
    const {
      error: { message, code },
    } = (await response.json()) as ErrorResponse;
    throw new RequestError({ message, code, status: response.status });
  }

  const blob = await response.blob();

  return blob;
};

export const requestDownloadWithFilename = async ({
  url,
  method,
  body,
  headers,
}: {
  url: string;
  method: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  body?: any;
  headers?: Record<string, string>;
}) => {
  const token = Cookies.get(ACCESS_TOKEN_KEY as string);
  const isBodyFormData = body instanceof FormData;
  const options = {
    headers: {
      ...(token && { Authorization: `Bearer ${token}` }),
      ...headers,
    },
    method,
    body: body ? (isBodyFormData ? body : JSON.stringify(body)) : null,
  };

  const response = await fetch(url, options);

  if (!response.ok) {
    const {
      error: { message, code },
    } = (await response.json()) as ErrorResponse;
    throw new RequestError({ message, code, status: response.status });
  }

  const blob = await response.blob();
  const contentDisposition = response.headers.get('Content-Disposition');
  // Extract the filename from the header if present
  let filename = 'downloaded_file'; // Fallback if no filename is provided
  if (contentDisposition?.includes('filename=')) {
    const matches = contentDisposition.match(/filename="?(.+?)"?(;|$)/);
    if (matches?.[1]) {
      filename = matches[1];
    }
  }

  return { blob, filename };
};
